import { readStored, writeStored } from "@/utils/storage";

export interface SupportedLanguage {
  code: string;
  /** Autonym — the language's name in its own language. */
  label: string;
}

export const SUPPORTED_LANGUAGES: readonly SupportedLanguage[] = [
  { code: "en", label: "English" },
  { code: "pt-BR", label: "Português" },
  { code: "es", label: "Español" },
];

const STORAGE_KEY = "labpro.language";

const isSupported = (code: string | null): code is string =>
  code != null && SUPPORTED_LANGUAGES.some((l) => l.code === code);

export const getStoredLanguage = (): string | undefined => {
  const stored = readStored(STORAGE_KEY);
  return isSupported(stored) ? stored : undefined;
};

export const setStoredLanguage = (code: string): void => writeStored(STORAGE_KEY, code);
